import { capitalizeAllIfLower, formatDate } from '@btime/helpers'
import { compose, prop, propOr } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'
import { useColor } from '../../../../../packages/kiti/components/theme/_hooks/colors'
import { incrementCheckout, shouldIncrementCheckout } from '../../../../../utils/helpers/serviceOrder'
import Expandable from '../../../../../components/helpers/Expandable'
import FlexGrid from '../../../../../components/structure/FlexGrid'
import Panel from '../../../../../components/structure/Panel'
import Text, { SmallText } from '../../../../../packages/kiti/components/presentation/Text'
import Tooltip from '../../../../../components/helpers/Tooltip'
import { UserAvatar } from '../../../../../components/presentation/Avatar'

const EventItem = ({ item, serviceOrder }) => {
  const { t } = useTranslation()
  const user = prop('createdBy', item) || prop('user', item)
  const userName = compose(capitalizeAllIfLower, propOr('', 'name'))(user)
  const serviceStatus = prop('status', item)
  const statusName = prop('name', serviceStatus)
  const color = useColor(serviceStatus.color)
  const shouldIncrementEventDate = item.eventDate >= serviceOrder.endDate && shouldIncrementCheckout(serviceOrder)
  const date = formatDate(
    'DD/MM/YY HH:mm',
    shouldIncrementEventDate ? incrementCheckout(item.eventDate) : item.eventDate
  )

  return (
    <Panel lineBorder noMargin smallPadding borderLeftColor={color}>
      <Text weight="500">
        {userName} {t('status.pastAction.' + statusName)}
      </Text>

      {!!item.description && (
        <Tooltip actionContent={`Motivo: ${item.reason.name}`} autoSize>
          {item.description}
        </Tooltip>
      )}
      <FlexGrid justify="space-between" gutter={0.3}>
        <SmallText size="xsmall">{date}</SmallText>
        <UserAvatar size="xsmall" user={user} />
      </FlexGrid>
    </Panel>
  )
}

const EventsList = ({ serviceOrder }) => {
  const events = propOr([], 'events', serviceOrder)
  return (
    <Expandable disabled={events.length < 6}>
      <FlexGrid direction="column" gutter={0.3} align="stretch" justify="flex-start">
        {events.map(item => (
          <EventItem key={item.id} item={item} serviceOrder={serviceOrder} />
        ))}
      </FlexGrid>
    </Expandable>
  )
}

export default EventsList
